import { clsx } from "clsx";
import React from "react";

import * as styles from "./Modal.css";
import { useModalContext } from "./context";
import { ModalFooterProps } from "./types";

/**
 * Footer component for the Modal
 *
 * Typically contains action buttons or other controls.
 * Positioned at the bottom of the modal with a fixed position.
 *
 * @returns {JSX.Element | null} The footer component or null if no children provided
 */
export const ModalFooter: React.FC<ModalFooterProps> = ({ children }) => {
  const { showBottomBorder } = useModalContext();

  if (typeof children === "undefined") return null;

  return (
    <footer
      className={clsx(styles.footer, showBottomBorder && styles.footerActive)}
    >
      {children}
    </footer>
  );
};
